import { ReactNode, FC } from 'react';
import { styled } from '@mui/system';
import Card from '@mui/material/Card';
import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { TCustomTheme } from '@mgm/common/theme';
import { BaseImage } from '@mgm/common/components/base';
import { useTranslation } from 'react-i18next';
import { MHidden } from '@mgm/common/components/responsive';
import gustoIcon from '../../static/payroll/ic_gusto.svg';
import adpIcon from '../../static/payroll/ic_adp.svg';
import quickbooksIcon from '../../static/payroll/ic_quickbooks.svg';
import ripplingIconLight from '../../static/payroll/ic_rippling_light.svg';
import onPayIcon from '../../static/payroll/onPay.png';
import surePayrollIcon from '../../static/payroll/surePayroll.png';

type TAutoLayout = {
  children: ReactNode
};

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 700,
  display: 'flex',
  flexDirection: 'column',
  background: 'linear-gradient(135deg, #6F48AD, #C365F2)',
  margin: theme.spacing(2, 0, 2, 2),
}));

const AuthLayout: FC<TAutoLayout> = ({ children }) => {
  const theme = useTheme() as TCustomTheme;
  const { t } = useTranslation('welcome');

  return (
    <>
      <MHidden width="mdDown">
        <SectionStyle>
          <Box
            pt={8}
            sx={{
              px: { lg: 12, md: 8 },
            }}
          >
            <Typography variant="h4" color="white">
              {t('yourUltimateSolution')}
            </Typography>
            <Typography pt={1} variant="caption" color="white">
              {t('enterYourCred')}
            </Typography>
          </Box>
          <Container
            sx={{
              pb: { xs: 7, md: 11 },
              pt: 4,
            }}
          >
            <Stack alignItems="center" spacing={1}>
              <Stack
                direction="row"
                flexWrap="wrap"
                justifyContent="center"
                sx={{ maxWidth: 680, overflow: 'hidden' }}
              >
                <BaseImage
                  disabledEffect
                  alt="algoritmo"
                  src="/login.png"
                  sx={{
                    height: { lg: 500, sm: 300, md: 400 },
                    mx: { xs: 2, md: 4 },
                    my: { xs: 2.5, md: 4 },
                  }}
                />
              </Stack>
            </Stack>
          </Container>
          <Box
            width="100%"
            position="absolute"
            bottom={20}
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            sx={{
              px: { lg: 8, md: 4 },
            }}
          >
            {[gustoIcon, quickbooksIcon, adpIcon, ripplingIconLight, onPayIcon, surePayrollIcon].map((icon, index) => (
              <BaseImage
                key={index?.toString()}
                src={icon}
                disabledEffect
                sx={{
                  background: 'white',
                  borderRadius: 2,
                  margin: theme.spacing(2), // Reduced margin for better spacing
                  padding: theme.spacing(0.5),
                  width: 50,
                  height: 50,
                  img: {
                    objectFit: 'contain',
                  },
                }}
              />
            ))}
          </Box>
        </SectionStyle>
      </MHidden>
      <Box position="absolute" top={30} right={30}>
        <img
          src="/favicon-512x512.png"
          alt="Background"
          style={{
            width: 75,
          }}
        />
      </Box>
      {children}
    </>
  );
};

export {
  AuthLayout,
};
